import type { SchemaOf } from '../../helpers';
import { Joi, makeAllRequired } from '../../helpers';

export interface IConfig {
  refreshPeriodSeconds: number;
  consoleNotifyPeriodSeconds: number;
  consolePresenceTimeoutSeconds: number;
  hilNotifyPeriodSeconds: number;
  hilPresenceTimeoutSeconds: number;
  notifyHilOffline: boolean;
  notifyConsolesOffline: boolean;
}

export const schemaMap: SchemaOf<IConfig> = {
  refreshPeriodSeconds: Joi.number(),
  consoleNotifyPeriodSeconds: Joi.number(),
  consolePresenceTimeoutSeconds: Joi.number(),
  hilNotifyPeriodSeconds: Joi.number(),
  hilPresenceTimeoutSeconds: Joi.number(),
  notifyHilOffline: Joi.boolean(),
  notifyConsolesOffline: Joi.boolean(),
};

export const schemaMapDefault = makeAllRequired(schemaMap);

export const defaultConfig: IConfig = {
  refreshPeriodSeconds: 120,
  consoleNotifyPeriodSeconds: 60,
  consolePresenceTimeoutSeconds: 120,
  hilNotifyPeriodSeconds: 60,
  hilPresenceTimeoutSeconds: 120,
  notifyHilOffline: false,
  notifyConsolesOffline: true,
};
